import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalIssueNavigatorBrowseIssueRedirectRoute: InvariantJiraRoute = {
	name: 'global-issue-navigator-browse-issue-redirect',
	path: '/browse/:issueKey?',
	query: ['jql|filter'],
};
